module.exports = __webpack_public_path__ + "static/img/doc-bg-new-h5.9884ea7b.png";